import { toPairs, sum, isEqual } from 'lodash';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useDeepCompareEffect } from 'react-use';

export const useUnreadConversations = () => {
    const unreadConversationsObject = useSelector((state) => state.conversations.unread);
    const unreadConversations = toPairs(unreadConversationsObject)
        .map((i) => ({
            contact: i[0],
            unreadMessages: i[1],
        }))
        .filter((i) => i.unreadMessages > 0);
    const unreadConversationsCount = unreadConversations.length;
    const unreadMessagesCount = sum(unreadConversations.map((i) => i.unreadMessages));
    const hasUnreads = unreadConversationsCount > 0;
    const [prev, setPrev] = useState(() => unreadConversationsObject);
    const [updateTimestamp, setUpdateTimestamp] = useState(0);

    useDeepCompareEffect(() => {
        if (isEqual(unreadConversationsObject, prev)) {
            return;
        }

        setPrev(unreadConversationsObject);

        for (const [id, messages] of Object.entries(unreadConversationsObject)) {
            const delta = messages - (prev[id] || 0);

            if (delta > 0) {
                setUpdateTimestamp(Date.now());

                break;
            }
        }
    }, [prev, unreadConversationsObject]);

    return {
        unreadConversations,
        unreadConversationsCount,
        unreadMessagesCount,
        updateTimestamp,
        hasUnreads,
    };
};
